import { createFileRoute, Link, useRouter } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';
import { useTitle } from '../hooks/use-title.hook';
import { LinkExternal } from '../components/LinkExternal';
import { ImageLightbox } from '../components/ScrollyPage/ImageLightbox';

export const Route = createFileRoute('/jarfalla/guide')({
    component: Index,
});

function Index() {
    const { t } = useTranslation();
    const router = useRouter();
    return (
        <>
            <div className="prose mx-auto mt-6">
                <button className="link" onClick={() => router.history.back()}>
                    {t('back')}
                </button>
            </div>
            <Guide />;
        </>
    );
}

function Guide() {
    const { t, i18n } = useTranslation(['guide.jarfalla']);

    useTitle(t('title'));

    return (
        <>
            <div className="prose mx-auto">
                <h1>{t('heading')}</h1>
                <p>
                    <Trans t={t} i18nKey={'p1'}>
                        aaa
                        <LinkExternal href="https://www.scb.se/hitta-statistik/regional-statistik-och-kartor/regionala-indelningar/regso---regionala-statistikomraden/">
                            bbb
                        </LinkExternal>
                    </Trans>
                </p>
                <p>{t('p2')}</p>
                <div className="flex flex-col">
                    <ImageLightbox
                        src={
                            i18n.language
                                ? `/images/guide_jarfalla_${i18n.language}.png`
                                : `/images/guide_jarfalla_sv.png`
                        }
                        srcThumbnail={
                            i18n.language
                                ? `/images/guide_jarfalla_${i18n.language}_small.png`
                                : `/images/guide_jarfalla_sv_small.png`
                        }
                    />
                    <div className="self-end flex gap-3">
                        <LinkExternal href="/Jarfallaanalysen_manual_20251209.pdf">
                            {t('download-as-pdf')}
                        </LinkExternal>
                        <div>
                            (
                            <LinkExternal href="/Jarfallaanalysen_manual_20251209_en.pdf">
                                EN
                            </LinkExternal>
                            )
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}